module.exports = __webpack_public_path__ + "img/bubbles.f867ce2a.svg";